import React, { useContext, useEffect, useState} from 'react';
import {Alert, Button, Col, Form, Input, Modal, Popconfirm, Row, Select, Tag} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiTrash, BiX} from "react-icons/bi";
import Rebut from "../../../../model/multilleure/rebuts/Rebut";
import {PostRebut} from "../../../../dao/multilleure/administracio/PostRebut";
import {AuthContext} from "../../../../config/AuthContext";
import {GetActivitatsJson} from "../../../../dao/multilleure/GetActivitatsJson";
import {BsArrowReturnLeft} from "react-icons/bs";
import {QuestionCircleOutlined} from "@ant-design/icons";
import Activitat from '../../../../model/inscripcions/Activitat';

interface RebutModalProps {
    element: Rebut | undefined | any;
    visible: boolean;
    onClose: (value: boolean) => void;
    handleSubmit: () => void;
    checkData: () => void;
    contactes: any;
}

const RebutModal: React.FC<RebutModalProps> = ({element, visible, onClose, handleSubmit, checkData, contactes}) => {
    const [form] = Form.useForm();
    const [IBAN, setIBAN] = useState("");
    const [isRd, setIsRd] = useState<boolean>(false);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [activitats, setActivitats] = useState<Activitat[]>();

    async function checkDades() {
        const dades = await GetActivitatsJson(page);
        setActivitats(dades);
    }

    useEffect(() => {
        setIsRd(element?.pagament === 'RD');
        checkDades()
    }, [IBAN]);

    async function submit () {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        await PostRebut(formData, page, userId);
        onClose(true);
    }

    const filterOption = (input: string, option: any) =>
        (option?.text+"" ?? '').toLowerCase().includes(input.toLowerCase()+"");


    const handleCancel = () => {
        onClose(false);
    };
    
    const activitatOptions = activitats?.map(act => ({
        label: act.nom,
        value: act.id, 
    }));


    const handleSelectChange = (selectedValue: number) => {
        // Realiza las acciones necesarias con el valor seleccionado
        const selectedContact: any = contactes?.find((contact : any) => (contact.id+"" === selectedValue+""));
        if (selectedContact) {
            //setIBAN(selectedContact.iban);
            form.setFieldsValue({ iban: selectedContact.iban });
            //setIsRd(true);
        }
    };


    function changePagament(value: string) {
        setIsRd(value === 'RD');
    }

    function deleteRemesa() {
        form.setFieldsValue({ estat: 'pendent' });
        form.setFieldsValue({ remesa: 0 });
        form.setFieldsValue({ pagat: 0 });
    }

    function retornarRebut() {
        form.setFieldsValue({ remesa: 0 });
        form.setFieldsValue({ estat: 'retornat' });
        form.setFieldsValue({ pagat: 0 });
    }

    return (
        <Modal
            title="Editar Rebut"
            open={visible}
            footer={[
            ]}
            width={1000}
            onCancel={handleCancel}
        >
            <Form form={form} initialValues={element} onFinish={submit}>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Preu" name="preu"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Pagat" name="pagat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Estat" name="estat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select>
                                <option value={"pendent"}>
                                    <Tag color={"orange"}>
                                        Pendent
                                    </Tag>
                                </option>
                                <option value={"pagat"}>
                                    <Tag color={"green"}>
                                        Pagat
                                    </Tag>
                                </option>
                                <option value={"retornat"}>
                                    <Tag color={"red"}>
                                        Retornat
                                    </Tag>
                                </option>
                                <option value={"anulat"}>
                                    <Tag color={"gray"}>
                                        Anulat
                                    </Tag>
                                </option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="Pagament" name="pagament"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select onChange={changePagament}>
                                <option value={"RD"}>
                                    <Tag color={"green"}>
                                        Domiciliat
                                    </Tag>
                                </option>
                                <option value={"TG"}>
                                    <Tag color={"orange"}>
                                        Targeta
                                    </Tag>
                                </option>
                                <option value={"EF"}>
                                    <Tag color={"red"}>
                                        Efectiu
                                    </Tag>
                                </option>
                                <option value={"TR"}>
                                    <Tag color={"blue"}>
                                        Transferència
                                    </Tag>
                                </option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="Concepte" name="concepte"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="Observacions" name="observacions">
                            <Input/>
                        </Form.Item>
                    </Col>
                    <hr/>
                    <Alert message={"Modifica primer el tipus de pagament perquè s'ompli automàticament el IBAN (en cas de 'RD')"} type={"success"} />
                    <Col span={12}>
                        <Form.Item label="Pagador" name="id_contacte"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                placeholder="Selecciona Pagador"
                                optionFilterProp="children"
                                onChange={handleSelectChange}
                                filterOption={filterOption}
                                options={contactes}
                            />
                        </Form.Item>
                    </Col>
                    {/*<Col span={2}>
                        <Button title={"Crear Rebut"} style={{backgroundColor: Colors.colors.color5}}
                                onClick={() => console.log("test")}><BiPlus/></Button>
                    </Col>*/}
                    <Col span={10}>
                        <Form.Item label="IBAN" name="iban"
                                   rules={isRd ? [{required: true, message: 'Aquest camp es obligatori'}] : []} hidden={!isRd}>
                            <Input value={IBAN} type={"text"}/>
                        </Form.Item>
                    </Col>
                    <Col span={10}>
                        <Form.Item label="Activitat" name="id_activitat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                placeholder="Selecciona Activitat"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={activitatOptions}
                                allowClear
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Remesa" name="remesa">
                            <Input type={"number"} disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Popconfirm
                            title="Remesa"
                            description="Vols eliminar definitivament la remesa d'aquest rebut? Un cop guardat no es pot revertir!"
                            onConfirm={deleteRemesa}
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        >
                            <Button title={"Borrar Remesa"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiTrash/></Button>
                        </Popconfirm>
                    </Col>
                    <Col span={2}>
                        <Popconfirm
                            title="Retornar Rebut"
                            description="Vols retornar aquest rebut? Se li eliminarà la remesa i un cop guardat no es pot revertir!"
                            onConfirm={retornarRebut}
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        >
                            <Button title={"Retornar Rebut"}
                                    style={{backgroundColor: Colors.colors.color5}}><BsArrowReturnLeft/></Button>
                        </Popconfirm>
                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default RebutModal;
